module.exports = __webpack_public_path__ + "static/img/Cover-fan.06d03086.jpg";